export const API_URL =
	process.env.NODE_ENV === 'production'
		? 'https://medepos-dash-api-eiozg.ondigitalocean.app/api/'
		: 'https://localhost:7177/api/';

// Maybe convert to a class
export const BRISTEC_ADMIN = 'bristec-admin';

export const USER = 'user';

export const MODERATOR = 'moderator';

export const ADMIN = 'admin';

export const LIGHT_GREY = '#f1f1f1ff';

export const WHITE = '#fff';
